import { Controller } from "../../../Controller";
import { AtendimentoPorProdutoService } from "../../../../Services/AssistenciaTecnica/Atendimento/AtendimentoPorProduto/AtendimentoPorProdutoService";

export function AtendimentoPorProdutosController(
    idProduto: number,
    pagina: number
) {
    return Controller(AtendimentoPorProdutoService(idProduto, pagina));
}
